import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import * as XCol from '../../../framework.core/XExportColumn';
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../uiControls/CurrencyLabel';
import SmartTable from '../../../uiControls/SmartTable';
import {JobNames} from "../../../framework.core/JobNames";
import {receivingList} from "../tableSettings";
import {WhRcvListItem} from "../../../fms.data/models/WhRcvListItem";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import { BillInvoiceCrdbFilterRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { findSecurityTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import _ from 'lodash';
import fastStorage from '../../../fastStorage';
import { paidValue } from '../../common/commonExportFormat';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  //}

  return (
    //<div className="ifms-table-default" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function VoidRenderer({cell}:any) {
  if (cell && cell.value === 1) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{color: 'red'}}>V</span>
      </div>
    );
  }
  return <div className="ifms-table-default"></div>;
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    &nbsp;
  </div>;
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useSelectedOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const appContext = useContext(ApplicationContext);
  const selectedElement = jobListContext.selectedElement as WhRcvListItem;
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/warehousing/receiving/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }
    openNewPage(history, '/warehousing/receiving/add', NavigationType.newPage);
  }

  async function deleteReceiving() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/receiving/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/receiving/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Receiving first', false, null, "warning");
      return;
    }

    if (selectedElement.rcvStatus !== 'Pre Receiving') {
      await showGlobalOkDialog('Can delete the Pre Receiving', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/WHRCV/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/WHRCV/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/WHRCV/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/WHRCV/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/WHRCV/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/WHRCV/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    , false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.WHRcv, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }
    const id = selectedElement.id;
    const editUrl = `/warehousing/receiving/edit/${id}`;
    const viewUrl = `/warehousing/receiving/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/warehousing/receiving/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    if(selectedElement.isVoid){
      jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, [editUrl, viewUrl]);
    }
    else
      jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);

  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/warehousing/receiving/edit/${id}`;
    const viewUrl = `/warehousing/receiving/view/${id}`;

    const listSec = findSecurityTask(appContext, FmsSecTask.WHRcv);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function switchToAcctInfo(rcv:WhRcvListItem|null) {
    if (!rcv) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.WHRcv}/${rcv.id}`, NavigationType.newPage);
  }

    async function viewBillings() {
      if (!selectedElement) {
        return;
      }
  
      const id = selectedElement.id;
  
      const viewUrl = `/warehousing/viewBillings/receiving/${id}`;
      openNewPage(history, viewUrl, NavigationType.newPage);
    }

  return {create,deleteReceiving, edit, view, switchToAcctInfo, viewBillings};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create,deleteReceiving, edit, view, viewBillings } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const selectedElement = jobListContext.selectedElement as WhRcvListItem;
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.WHRcv);

  async function processFileLock() {
    if(selectedElement.rcvStatus !== 'Received'){
      await showGlobalOkDialog('Cannot op close before receipt confirm');
      return;
    }
    if(selectedElement.receiveDate === null){
      await showGlobalOkDialog('Invalid InDate');
      return;
    }
    const fileLockResult = await appContext.api.opClose(JobNames.WHRcv, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult);
      return;
    }
    
    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/receiving/edit/${selectedElement.id}`)) {
      const editModelKey = `editReceiving${selectedElement.id}-/warehousing/receiving/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }
  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel, },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Billings', shortcut: 'F7', separator: true },
    { label: selectedElement?.isClosed ? 'OP Open' : 'OP Close', shortcut: '', separator: false, hidden: !showFileLock  },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="receiving-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteReceiving();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 6:
        viewBillings();
        break;
      case 7:
        processFileLock();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as WhRcvListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalOP && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.WHRcv, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as WhRcvListItem;

  const { deleteReceiving, edit, view, viewBillings } = useSelectedOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);

  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/receiving/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/receiving/view/${id}`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.WHRcv, selectedElement, appContext, showGlobalYesNoDialog, null);
    if(args){
      viewReport(args, "", true);
    }
  }

  const hasSelectedRow = !!selectedElement;

  const listSec = findSecurityTask(appContext, FmsSecTask.WHRcv);
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='receiving-list-add-button' display="primary" size="regular" link="/warehousing/receiving/add" disabled={!canBeAdd} label="New" />&nbsp;
        <PrimaryButton name='receiving-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='receiving-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='receiving-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteReceiving}>Delete</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton name='receiving-list-viewBillings-button' size="regular" onClick={viewBillings}>{constants.List_Billings}</PrimaryButton>&nbsp;
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.WHRcv);

  const {create, edit, view, viewBillings} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F7") {
      //jobListContext.setInfoAreaContent('custom');
      viewBillings();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F7', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  function onLinkToAccounting(entity: any) {
    if (!entity || !entity.category || !entity.number) {
      return;
    }

    if (entity.category === 'Bill') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/bill/otherShipment', 'billNo', 'Bill #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/bill/otherShipment`, NavigationType.newPage);
    }
    if (entity.category === 'Invoice') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/otherShipment', 'invoiceNo', 'Invoice #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/invoice/otherShipment`, NavigationType.newPage);
    }
    if (entity.category === 'CrDb') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/otherShipment', 'crdbNo', 'CrDb #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/crdb/otherShipment`, NavigationType.newPage);
    }
  }

  async function loadInfoAreaInvoiceBillCrDb(id: string) {
    const apiResult = await appContext.api.getOceanImportMblInfoAreaBics(id);
    if (!apiResult) {
      return null;
    }

    const tableOptions: ApplicableTableSettings = {
      tableName: 'infoAreaBicTable',
      ...infoAreaBicTable,
      data: apiResult,
      
      rowRenderers: [
        {accessor: 'date', Cell: TextRenderer},
        {accessor: 'category', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'number', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting)},
        {accessor: 'companyName', Cell: TextAlignLeftRenderer},
        {accessor: 'cur', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true)},
      ],
    };

    return (
      <div style={{width: `${infoAreaBicTable.width}`, marginLeft: 'auto', marginRight: 'auto'}}>
        <SmartTable {...tableOptions} />
      </div>
    );
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.WHRcv}
      jobId={(jobListContext.selectedElement as WhRcvListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Other Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.WHRcv,
      'WhRcvListItem',
      WhRcvListItem.calculateSearchParameters(search, WhRcvListItem.MapSearchFields, ['isVoid']),
      1,
      search.pageSize,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: WhRcvListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'isVoid',
        renderer: VoidFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v === 'V' ? 1 : 0,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return WhRcvListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === 'p') colRenderer.Cell = PaidRenderer;
      // else if (x.dataIndex === 'isVoid') colRenderer.Cell = VoidRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({accessor: 'p', changedValue: (value: any)=> { return value['p']}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  receivingList;
    const cols = WhRcvListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: WhRcvListItem) {
    return row && row.id ? `/warehousing/receiving/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Receiving List';
  };
  
  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default ListView;
